import {HttpErrorResponse, HttpHandlerFn, HttpRequest} from '@angular/common/http';
import {inject} from '@angular/core';
import {catchError} from 'rxjs';
import {AuthService} from '@on-the-go-web/helpers/services/auth.service';

export const authErrorInterceptor = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
  const authService = inject(AuthService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401 && req.headers.has('authToken')) {
        authService.setAuthData(undefined);
      }
      throw error;
    }),
  );
};
